import { Component, OnInit } from '@angular/core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcTranslation} from 'exc-core';

@Component({
  selector: 'app-data-import-upload-confirm-modal',
  templateUrl: './data-import-upload-confirm-modal.component.html',
  styles: []
})
export class DataImportUploadConfirmModalComponent extends ExcTranslation implements OnInit {

  constructor(private overlayRef: OverlayRef, private overlayConfig: OverlayConfig) {
    super();
  }

  ngOnInit() {
  }

}
